export default {
    initialiseStore: (state, initialState) => {
        for (const prop in state) {
            if (Object.hasOwnProperty.call(initialState, prop)) {
                state[prop] = initialState[prop];
            }
        }
    },
    updateLogin: (state, login) => (state.login = login),
    updatePassword: (state, password) => (state.password = password),
    updateTerms: (state, terms) => (state.terms = terms),
    updateMailing: (state, mailing) => (state.mailing = mailing),
    updateName: (state, name) => (state.name = name),
    updateFirstname: (state, firstname) => (state.firstname = firstname),
    updateLastname: (state, lastname) => (state.lastname = lastname),
    updatePhoneCountry: (state, phoneCountry) => (state.phone_country = phoneCountry),
    updatePhoneNumber: (state, phoneNumber) => (state.phone_number = phoneNumber),
    updateCountry: (state, country) => (state.country = country),
    updateLang: (state, lang) => (state.lang = lang),
    updateRecaptcha: (state, token) => (state['g-recaptcha'] = token),
    updateUtms: (state, { utm_source, utm_medium, utm_campaign, keyword, gclid }) => {
        state.utm_source = utm_source;
        state.utm_medium = utm_medium;
        state.utm_campaign = utm_campaign;
        state.utm_keyword = keyword;
        state.utm_gclid = gclid;
    },
    updateGoogle: (state, google) => (state.google = google),
};
